import { Button } from '@repo/videa-components/src/ui/button';
import type { ButtonProps } from '@repo/videa-components/src/ui/button';

interface PreferenceButtonProps extends ButtonProps {
  active?: boolean;
  startIcon?: React.ReactNode;
}

export const PreferenceButton = ({
  active = false,
  className = '',
  startIcon,
  children,
  ...props
}: PreferenceButtonProps) => {
  return (
    <Button
      variant="outline"
      data-testid="preference-button"
      className={`
        vai-box-border vai-flex vai-text-[0.75em] vai-font-bold vai-text-sapphire-500 
        vai-border vai-border-sapphire-500 vai-px-4 vai-py-2
        hover:hover:vai-text-sapphire-500
        ${active ? 'vai-bg-sapphire-500 vai-text-white' : ''}
        ${className}
      `}
      {...props}
    >
      {startIcon && startIcon}
      {children}
    </Button>
  );
};
